import * as crypto from 'node:crypto';

import { loggerFactory } from '@ria-client/logger';
import { NextRequest, NextResponse } from 'next/server';

export const WORDPRESS_ACTIVE_SESSION_PREFIX = 'wordpress_logged_in_';
export const WORDPRESS_ACTIVE_SESSION_COOKIE = 'wordpress_session_active';

export function validateWpLogin(cookieStore: { getAll(): Array<{ name: string }> }): boolean {
  return cookieStore.getAll().some(cookie => cookie.name.startsWith(WORDPRESS_ACTIVE_SESSION_PREFIX));
}

/**
 * Computes a non-reversible 16-hex-char fingerprint of the WordPress session
 * by hashing the WP login cookie name:value pairs (sorted for stability).
 * Returns 'unknown' when no WP cookies are found.
 */
export function fingerprintWpSession(
  cookieStore: { getAll(): Array<{ name: string; value: string }> },
): string {
  const wpCookies = cookieStore
    .getAll()
    .filter(cookie => cookie.name.startsWith(WORDPRESS_ACTIVE_SESSION_PREFIX))
    .sort((a, b) => a.name.localeCompare(b.name));

  if (wpCookies.length === 0) {
    return 'unknown';
  }

  const concatenated = wpCookies.map(c => `${c.name}:${c.value}`).join('|');

  return crypto.createHash('sha256').update(concatenated).digest('hex').slice(0, 16);
}

export const setIsWpLoggedInCookie = (request: NextRequest, response: NextResponse): void => {
  const hasActiveWPSession = request.cookies.getAll().some(cookie => {
    return cookie.name.startsWith(WORDPRESS_ACTIVE_SESSION_PREFIX);
  });

  if (hasActiveWPSession) {
    response.cookies.set(WORDPRESS_ACTIVE_SESSION_COOKIE, '1');
  }
};

export const rewriteWordpressPreviews = (request: NextRequest): NextResponse => {
  const logger = loggerFactory({
    component: 'rewriteWordpressPreviews',
    path: `/src/lib/middleware/wordpress`,
  });
  logger.trace('ENTER: Wordpress preview check.');

  const url = new URL(request.url);
  const pathname = url.pathname;
  const rewriteUrl = new URL(`${pathname}/draft`, request.url);
  rewriteUrl.search = url.search;

  logger.info({ rewriteUrl }, 'Wordpress preview found.');

  return NextResponse.rewrite(rewriteUrl);
};
